import { TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  crudActions,
  DatasetTableConfig,
  TableConfigBuilder,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { OrgVariablesModel } from '@models/org-variables.model';

export type VariableCellContext = CellTemplateContext<OrgVariablesModel.Variable>;

export interface CreateVariablesTableConfigDependencies {
  valueCellTemplate: TemplateRef<VariableCellContext>;
  typeCellTemplate: TemplateRef<VariableCellContext>;
}

export function createVariablesTableConfig(
  dependencies: CreateVariablesTableConfigDependencies,
): DatasetTableConfig<OrgVariablesModel.Variable> {
  const builder = new ColumnBuilder<OrgVariablesModel.Variable>();

  return new TableConfigBuilder<OrgVariablesModel.Variable>()
    .columns([
      builder
        .column('name')
        .label('VARIABLES.TABLE.NAME')
        .width('minmax(150px, 1fr)')
        .mobileVisible()
        .cardMode('label-only')
        .build(),

      builder
        .column('type')
        .label('VARIABLES.TABLE.TYPE')
        .width('minmax(70px, 0.8fr)')
        .cellTemplate(dependencies.typeCellTemplate)
        .mobileVisible()
        .cardMode('label-only')
        .build(),

      builder
        .column('value')
        .label('VARIABLES.TABLE.VALUE')
        .width('minmax(80px, 1fr)')
        .cellTemplate(dependencies.valueCellTemplate)
        .cardMode('label-only')
        .build(),
    ])
    .actions(crudActions<OrgVariablesModel.Variable>())
    .trackBy('name')
    .rowHeight(52)
    .build();
}
